import { arrayWithoutSubset } from '@ms/yammer-data-support';

import { Thread } from '../types';

import { ThreadsPinnedToFeeds } from './types';

type RemoveThreadFromAnyPinnedInstance = (state: ThreadsPinnedToFeeds, id: Thread['id']) => ThreadsPinnedToFeeds;
export const removeThreadFromAnyPinnedInstance: RemoveThreadFromAnyPinnedInstance = (state, id) =>
  Object.keys(state).reduce(
    (newState: ThreadsPinnedToFeeds, entityId) => ({
      ...newState,
      [entityId]: {
        ...state[entityId],
        threadIds: arrayWithoutSubset(state[entityId].threadIds, [id]),
      },
    }),
    {}
  );

type RemoveThreadFromAnyPinnedInstanceIfDeleted = (
  state: ThreadsPinnedToFeeds,
  id: Thread['id'],
  isDeleted: boolean
) => ThreadsPinnedToFeeds;
export const removeThreadFromAnyPinnedInstanceIfDeleted: RemoveThreadFromAnyPinnedInstanceIfDeleted = (
  state,
  id,
  isDeleted
) => (isDeleted ? removeThreadFromAnyPinnedInstance(state, id) : state);
